import React, { Component } from 'react';

class Review extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

        return (
            <div className="client-review-area client-review-area-home pd-top-70">
                <div className="container">

                    {/* TÍTULO CENTRALIZADO */}
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <p className="sub-title">Reviews das viagens</p>
                        </div>
                    </div>

                    <div className="row mt-4">

                        {/* REVIEW 1 */}
                        <div className="col-lg-6">
                            <div className="single-client-review wow animated fadeInLeft" data-wow-duration="1s" data-wow-delay="0.3s">

                                <div className="tp-review-meta">
                                    <i className="ic-yellow fa fa-star" />
                                    <i className="ic-yellow fa fa-star" />
                                    <i className="ic-yellow fa fa-star" />
                                    <i className="ic-yellow fa fa-star" />
                                    <i className="ic-yellow fa fa-star" />
                                    <span>5.0</span>
                                </div>

                                <p>"Super atenciosos, nos ajudou a realizar o sonho da nossa família"</p>

                                <div className="media mt-3">
                                    <div className="media-left">
                                        <img src={publicUrl+"assets/img/client/1.png"} alt="client" />
                                    </div>
                                    <div className="media-body">
                                        <h6>Renata Monteiro</h6>
                                        <p>Turista</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* REVIEW 2 - DUPLICADO */}
                        <div className="col-lg-6">
                            <div className="single-client-review wow animated fadeInLeft" data-wow-duration="1s" data-wow-delay="0.4s">

                                <div className="tp-review-meta">
                                    <i className="ic-yellow fa fa-star" />
                                    <i className="ic-yellow fa fa-star" />
                                    <i className="ic-yellow fa fa-star" />
                                    <i className="ic-yellow fa fa-star" />
                                    <i className="ic-yellow fa fa-star" />
                                    <span>5.0</span>
                                </div>

                                <p>"Tem um bom atendimento são atenciosos e tiram todas as dúvidas"</p>

                                <div className="media mt-3">
                                    <div className="media-left">
                                        <img src={publicUrl+"assets/img/client/2.png"} alt="client" />
                                    </div>
                                    <div className="media-body">
                                        <h6>Lucas Telles</h6>
                                        <p>Turista</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

export default Review;
